/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountListRequest {
    getFixupPrototypeFunction() { return MasterAccountListRequest.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountListRequest>): MasterAccountListRequest {
        let obj = Object.assign(new MasterAccountListRequest(), model);
        MasterAccountListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountListRequest>): MasterAccountListRequest {
        if (!model) return null;
        return MasterAccountListRequest.newInstance(<MasterAccountListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountListRequest) {
        if (!obj) return;

        models.MasterAccountListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountListRequest): boolean {
        Object.setPrototypeOf(obj, MasterAccountListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.MasterAccountListFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.MasterAccountDetailsSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.MasterAccountDetailsSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.MasterAccountListFilters;

}
